export default __webpack_public_path__ + "static/media/sortingIcon.719abe92.svg";